import React from 'react'

import SvgSprite from 'airship/patterns/svg-sprite'

import styles from './styles.module.css'

const CenteredLogoBanner: React.FC = () => {
  return (
    <div className={styles.banner}>
      <SvgSprite
        name={'airship-logo-horizontal'}
        displayClasses={styles.sprite}
        title={'Airship Logo Banner'}
      />
    </div>
  )
}

export default CenteredLogoBanner
